<template>
  <div :class="$style.view">
    <header :class="$style.header">
      <h3 :class="$style.title">このユーザーに送信したアプローチ</h3>
    </header>

    <div :class="[$style.view__comment, $style.comment]">
      <p :class="[$style.comment__body, $style.body]">
        {{ plannerComment }}
      </p>
      <ul
        v-for="(plannerSelection, index) in plannerSelections"
        :key="index"
        :class="$style.selections"
      >
        <li :class="$style.item">{{ plannerSelection }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  plannerComment: string
  plannerSelections: ReadonlyArray<string>
  plannerCommentCount: number
  sameBranchPlannerCommented: boolean
}>()
</script>

<style lang="scss" module>
.view {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.title {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  font-weight: bold;
  line-height: 28px;
}

.body {
  color: $color-text-and-object-low-emphasis;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  white-space: pre-line;
  word-break: break-all;
}

.selections {
  margin-left: 16px;
}

.item {
  color: $color-text-and-object-low-emphasis;
  font-size: 14px;
  font-weight: bold;
  list-style: circle;
}
</style>
